(function () {
    "use strict";

    angular
        .module("app")
        .directive("qualitySearchHelp", ["SearchFactory", qualitySearchHelp]);

    function qualitySearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.qualityName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.qualityName === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.qualitySearch(function (quality) {
                        scope.qualityName = quality ? quality.QualityCategoryKey : "";
                        scope.displayValue = scope.qualityName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, [scope.displayValue]);
                };

                scope.$watch("qualityName", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.qualityName;
                scope.prevDisplayValue = scope.displayValue;

            },
            scope: { qualityName: "=", readOnly: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

